export const ReportHostTasksText = {
  titleText: 'Konten Host',
  searchPlaceholder: 'Cari...',
  startDatePlaceholder: 'Tanggal Mulai',
  endDatePlaceholder: 'Tanggal Selesai',
  brandPlaceholder: 'Pilih Brand',
  buttonExportText: 'Export',
  buttonDetailText: 'Detail',
};
